export default {
      id: "video-event_turn-usage",
      viewBox: "0 0 28.744 24.637",
      url: __webpack_public_path__ + "img/icons.svg#video-event_turn",
      toString: function () {
        return this.url;
      }
    }